import { gql } from "@apollo/client";

export const WHOAMI = gql`
  {
    whoami {
      role
      firstName,
      lastName,
      businessSubjectName,
      businessSubjectId,
      superAdmin
      canActAs
      actingAs {
        type
        id
        name
        role
      }
    }
  }
`

// Super admins only (ACT_AS authority): every bank, company and organisation they may act as.
export const ACT_AS_TARGETS = gql`
  query actAsTargets {
    actAsTargets {
      type
      id
      name
      status
    }
  }
`;

// From the next request on the caller is a user of that entity with that role (see backend
// ActAsService). The page reloads afterwards so every query re-runs as the new principal.
export const ACT_AS = gql`
  mutation actAs($input: ActAsInput!) {
    actAs(input: $input) {
      role
      businessSubjectName
      actingAs {
        type
        id
        name
        role
      }
    }
  }
`;

export const STOP_ACTING_AS = gql`
  mutation stopActingAs {
    stopActingAs {
      role
      actingAs {
        id
      }
    }
  }
`;

// Profile → API tokens: personal tokens act as the signed-in user (backend `user_api_token`).
// The plaintext exists only in the create response — never cache or log it.
export const MY_API_TOKENS = gql`
  query MyApiTokens {
    myApiTokens {
      id
      name
      keyPrefix
      scopes
      createdDate
      lastUsedAt
      expiresAt
      revokedAt
    }
  }
`;

export const CREATE_USER_API_TOKEN = gql`
  mutation CreateUserApiToken($input: UserApiTokenCreate!) {
    createUserApiToken(input: $input) {
      plaintextToken
      token {
        id
        name
        keyPrefix
        scopes
        createdDate
        expiresAt
      }
    }
  }
`;

export const REVOKE_USER_API_TOKEN = gql`
  mutation RevokeUserApiToken($id: Int!) {
    revokeUserApiToken(id: $id) {
      id
      revokedAt
    }
  }
`;
